import { render } from "./AttributeComponent.vue?vue&type=template&id=81bb9606&scoped=true"
import script from "./AttributeComponent.vue?vue&type=script&lang=js"
export * from "./AttributeComponent.vue?vue&type=script&lang=js"

import "./AttributeComponent.vue?vue&type=style&index=0&id=81bb9606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81bb9606"]])

export default __exports__